import DocumentTemplateCard from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/Sections/DocumentTemplates/DocumentTemplateCard';
import type DocumentTemplatesListView from '@UI/Store/DocumentTemplates/Views/Document/DocumentTemplatesListView';
import type DocumentTemplateVersionsListView from '@UI/Store/DocumentTemplates/Views/Document/DocumentTemplateVersionsListView';
import type DocumentTypesListView from '@UI/Store/DocumentTypes/Views/DocumentTypesListView';
import type FacilityTemplateOverridesListView from '@UI/Store/DocumentTemplates/Views/TemplateAssignements/FacilityTemplateOverridesListView';
import type TemplateAssignmentsListView from '@UI/Store/DocumentTemplates/Views/TemplateAssignements/TemplateAssignmentsListView';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Grid } from '@verclam/grid-system';

const sectionStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`;

type Props = {
	readonly organizationId: number;
	readonly templates: DocumentTemplatesListView;
	readonly templateVersions: DocumentTemplateVersionsListView;
	readonly organizationAssignments: TemplateAssignmentsListView;
	readonly facilityOverrides: FacilityTemplateOverridesListView;
	readonly documentTypes: DocumentTypesListView;
};

/**
 * "Gabarits": one `DocumentTemplateCard` per deposited gabarit, archived ones included. `isAssigned`
 * is computed here, once per gabarit, from data this section already has — the organization's own
 * assignments and the facility overrides across the organization, feeding the archive guard.
 */
const DocumentTemplatesSection: React.FC<Props> = ({
	organizationId,
	templates,
	templateVersions,
	organizationAssignments,
	facilityOverrides,
	documentTypes,
}) => {
	return (
		<section css={sectionStyle}>
			<Grid columns={2} rowGap={1.25} columnGap={1.25}>
				{templates.list.map((template) => {
					return (
						<DocumentTemplateCard
							key={template.id}
							template={template}
							organizationId={organizationId}
							templateVersions={templateVersions}
							organizationAssignments={organizationAssignments}
							facilityOverrides={facilityOverrides}
							documentTypes={documentTypes}
						/>
					);
				})}
			</Grid>
		</section>
	);
};

export default DocumentTemplatesSection;
